<template>
  <div class="image-container">
    <div @click="startCasinoLauncher(gameId)" v-if="gameId" :id="gameId" class="game-image lazy" :data-src="mediaServer('/static/casino/games/' + gameId + '/assets/icon/' + gameId + '_300x300.jpg')"></div>
  </div>
</template>
<script>
import Casino from '@/components/mixins/Casino'
import Url from '@/components/mixins/Url'
export default {
  name: 'casinoGameImage',
  props: ['gameId'],
  mixins: [Casino, Url],
  data () {
    return {
      isGameInfoOpen: false
    }
  },
  computed: {},
  methods: {},
  mounted () {}
}
</script>

<style lang="stylus" scoped>
@import '~@/css/config'
@import '~@/css/mixins'
.image-container
  height 100%
  .game-image
    background-size: cover
    background-position: center
    background-repeat: no-repeat
    height: 100%
    width: 100%
    border-radius: 6px
</style>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoGameImage.vue